module.exports = __webpack_public_path__ + "img/logo-dark.2c6b0dc3.png";